// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class AutocompleteService {
   azDatabaseProxyUrl: any
   config: any
   defaultTopicPriority: any
   i18n: any
   l10n: any
   topicsDisplay: any
   constructor(config: any, i18n: any, l10n: any) {
      this.getUrl = this.getUrl.bind(this)
      this.getAzSearchUrl = this.getAzSearchUrl.bind(this)
      this.updateTopics = this.updateTopics.bind(this)
      this.prioritizeResults = this.prioritizeResults.bind(this)
      this.transformResponse = this.transformResponse.bind(this)
      this.i18n = i18n
      this.l10n = l10n
      this.config = config.data.autocomplete
      this.azDatabaseProxyUrl = config.data.widgets.azDatabaseProxyUrl
      this.defaultTopicPriority = [
         'credo',
         'eb',
         'gale',
         'netadvance',
         'worldbook',
         'wikipedia'
      ]
      // create list of topic sections that are configured to display
      this.topicsDisplay = _.map(this.config.topicsDisplay, (topicSection: any) => {
         return topicSection.name.slice(0, topicSection.name.indexOf('_label'))
      })
   }

   getUrl() {
      const currentLocale = this.l10n.getStandardLocale()
      let acUrl = `${this.config.url}client=${this.config.libhash}&size=${this.config.numResults}&hl=true&language=${currentLocale.split('-')[0]}`
      if (!this.config.dbRecsEnabled) {
         acUrl += "&index[]=best-bets&index[]=popular-searches&index[]=topics"
      }
      return acUrl
   }

   getAzSearchUrl(type = 'suggest') {
      const highlight = type === 'search' // only search supports highlighting, not yet in AC (suggest)
      let proxy = ''
      if (this.azDatabaseProxyUrl) {
         proxy = `&proxy=${encodeURIComponent(this.azDatabaseProxyUrl)}`
      }

      return `${this.config.azSearchUrl}/${type}?hl=${highlight}&client=${this.config.libhash}${proxy}`
   }

   updateTopics(topics: any) {
      const topicPriority = this.config.topicSourcePriority || this.defaultTopicPriority
      return _.chain(topics).map((topic: any) => {
      // remove topic sections that are NOT configured to display
         if (!this.topicsDisplay.includes('encyclopedia')) { delete topic.encyclopedia }
         if (!this.topicsDisplay.includes('recommended_research_guides')) { delete topic.libguide }
         if (!this.topicsDisplay.includes('related_topics')) { delete topic.relatedTopics }

         if (topic.encyclopedia != null) {
            // filter out topics that aren't in priority list
            const encyclopediaEntries = _.filter(topic.encyclopedia, (entry: any) => {
               entry.order = topicPriority.indexOf(entry.source)
               return entry.order > -1
            })
            // sort by 'order' property
            topic.encyclopedia = _.sortBy(encyclopediaEntries, (entry: any) => entry.order)
         }

         // set 'text' property to 'topic' property
         topic.text = topic.topic

         if (!topic.encyclopedia?.length && !topic.libguide?.length && !topic.relatedTopics?.length) { return null }

         return topic
      }).compact().value()
   }

   prioritizeResults(results: any) {
      let resultsToFill = this.config.numResults

      // take top 2 topics
      if (results.topics != null) { results.topics = this.updateTopics(results.topics).slice(0, 2) }

      // take top 2 best bets
      if (results.bestBets != null) { results.bestBets = results.bestBets.slice(0, 2) }

      // take top 1 of each if they both exist
      if ((results.topics != null) && (results.bestBets != null)) {
         results.topics = results.topics.slice(0, 1)
         results.bestBets = results.bestBets.slice(0, 1)
         resultsToFill -= 2
      } else if (results.topics != null) {
         resultsToFill -= results.topics.length
      } else if (results.bestBets != null) {
         resultsToFill -= results.bestBets.length
      }

      // add 2 db recs
      if (results.dbRecs != null) {
         results.dbRecs = results.dbRecs.slice(0, 2)
         resultsToFill -= results.dbRecs.length
      }

      // fill in remaining spots w/popular searches
      if (results.popularSearches != null) {
         results.popularSearches = results.popularSearches.slice(0, resultsToFill)
      }

      return results
   }

   transformResponse(jsonResponse: any) {
      const culledResults = this.prioritizeResults(jsonResponse)
      const results = _.map(culledResults, function(val: any, key: any) {
      // go from camel case to kebab case
         let groupClass, order, resultJson
         const templateName = key.replace(/[A-Z]/g, (match: any, offset: any) => {
            return (offset > 0 ? '-' : '') + match.toLowerCase()
         })

         // annotate results
         _.each(val, function(result: any) {
            result.rawTitle = (result.title = result.orig?.length ?
               result.orig[0]
               :
               result.parsed_text || result.text)
            if (result.highlighted?.length) {
               // set title to first highlighted value
               return result.title = result.highlighted[0]
            }
         })

         // TODO: set order based off of client configs
         if (val.length !== 0) {
            switch (key) {
               case 'topics':
                  order = 1
                  groupClass = 'library-rec'
                  break
               case 'bestBets':
                  order = 2
                  groupClass = 'library-rec'
                  break
               case 'dbRecs':
                  order = 3
                  groupClass = 'search'
                  break
               case 'popularSearches':
                  order = 4
                  groupClass = 'search'
                  break
            }
         }

         return resultJson = {
            groupClass,
            data: val,
            order,
            template: `<li ${templateName}-template></li>`
         }
      })
      return _.chain(results).compact().sortBy('order').value()
   }
}

AutocompleteService.$inject = ['configService', 'translationService', 'localizationService']

angular.module('summonApp.services')
   .service('autocompleteService', AutocompleteService)
